if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression-polynomial/~/ml-matrix/src/symbol-species.js
// module id = 46
// module chunks = 0